export default {
  // Toolbar
  projectRegion: 'Project Region',
  selectPlaceholder: 'Please select parent menu',
  addProject: 'Add Project',

  // Table column headers
  projectName: 'Project Name',
  bindCode: 'Bind Code',
  projectDesc: 'Project Description',
  createTime: 'Create Time',
  action: 'Action',
  routeName: 'Route Name',

  // Buttons
  deviceList: 'Device List',
  edit: 'Edit',
  cancel: 'Cancel',
  confirm: 'Confirm',

  // Form labels
  projectRegionLabel: 'Project Region',
  projectNameLabel: 'Project Name',
  projectDescLabel: 'Project Description',

  // Modal titles
  deviceListTitle: 'Device List',
  addProjectTitle: 'Add Project',
  editProjectTitle: 'Edit Project',

  // Confirmation dialog
  deleteConfirm: 'Are you sure to delete',

  // Success messages
  deleteSuccess: 'Deleted successfully',
  addSuccess: 'Added successfully',
  editSuccess: 'Modified successfully',

  // Device page specific
  // Breadcrumb navigation
  projectListBreadcrumb: 'Project List',
  deviceListBreadcrumb: 'Device List',
  deviceDetailsBreadcrumb: 'Device Details',

  // Device type menu
  aircraft: 'Aircraft',
  dock: 'Dock',
  gateway: 'Gateway',

  // Table column headers
  deviceModel: 'Device Model',
  deviceSN: 'Device SN',
  deviceNickname: 'Device Nickname',
  firmwareVersion: 'Firmware Version',
  onlineStatus: 'Online Status',
  belongProject: 'Belong Project',
  joinOrganizationTime: 'Join Organization Time',
  onlineTime: 'Online Time',

  // Status
  online: 'Online',
  offline: 'Offline',

  // Tooltips
  confirmModify: 'Confirm Modify',
  cancelModify: 'Cancel Modify',
  deviceLog: 'Device Log',
  alarmInfo: 'Alarm Info',
  editDevice: 'Edit',
  deleteDevice: 'Delete',

  // Confirmation dialog
  deleteDeviceConfirm: 'Are you sure to delete this device?',
  deleteDeviceTitle: 'Delete Device',

  // Upgrade related
  deviceUpgrade: 'Device Upgrade',
  upgradeFailed: 'Upgrade Failed',
  errorCode: 'Error Code',
}
